export default "__VITE_ASSET__mOzbPBb8__"